import React from 'react';
import { connect } from 'react-redux';
import { PageBody, PageContent } from '@bit/knotchinc.web-react-components.page';
import FilterSideMenu from '@bit/knotchinc.web-react-components.filter-side-menu';
import DateFilter from '@bit/knotchinc.web-react-components.date-filter';
import { ComponentTabContainer, ComponentTab } from '@bit/knotchinc.web-react-components.tabs';
import TagFilter from 'components/Global/Filters/TagFilter/TagFilter.jsx';
import EntityFilter from 'components/Global/Filters/EntityFilter/EntityFilter.jsx';
// import SearchFilter from 'components/Global/Filters/SearchFilter/SearchFilter.jsx';
import ChecklistFilter from 'components/Global/Filters/ChecklistFilter/ChecklistFilter.jsx';
import SelectedFiltersBar from 'components/Global/Filters/SelectedFiltersBar/SelectedFiltersBar.jsx';
import CompareToggle from 'components/Pages/Entity/InsightsTabs/CompareToggle/CompareToggle.jsx';
import { SET_KEYWORDS_FILTER, SET_BRANDS_FILTER, SET_CATEGORIES_FILTER } from 'components/Global/Filters/actions.js';
import { TOGGLE_COMING_SOON_MODAL } from 'components/Pages/Home/actions.js';
import Mixpanel from 'helpers/Mixpanel.js';
import {
  fetchPublisherKeywords,
  fetchPublisherCategories,
  fetchPublisherBrands,
  fetchEntityContentInsights,
  fetchPublishersKeywordsInsights,
  fetchPublishersBrandsInsights,
  SET_INSIGHTS_FILTERS,
} from './actions';
import { LeftSideBarWrapper, ExportPDFButton, InsightsTabContainer } from './styled.js';
import { ContentInsightsTab, BrandsInsightsTab, KeywordsInsightsTab } from './InsightsTabs';

class PublisherInsightsView extends React.Component {
  componentDidMount() {
    const { updateContentType, filters, match: { params: { entityId } }, entityType,
    } = this.props;

    if (filters.content_type === 'owned') {
      updateContentType('paid');
    }

    Mixpanel.track(`view ${entityType} Paid Analytics`, { id: entityId });
  }

  render() {
    const {
      categoriesList,
      keywordsList,
      brandsList,
      filters,
      getBrands,
      getCategories,
      getKeywords,
      getContentInsights,
      getKeywordsInsights,
      getBrandsInsights,
      match: { params: { entityId } },
      entityType,
      toggleComingSoonModal,
    } = this.props;

    return (
      <PageBody>
        <LeftSideBarWrapper>
          <CompareToggle entityType={entityType} entityId={entityId} />
          <FilterSideMenu clearAll={() => {}}>
            <DateFilter filterAction={SET_INSIGHTS_FILTERS} />
            {/* <SearchFilter filterAction={SET_INSIGHTS_FILTERS} /> */}
            <TagFilter
              title="keywords"
              type="keyword_tags"
              filters={keywordsList.filters}
              items={keywordsList}
              fetch={(clear) => getKeywords(clear)}
              selectedItems={filters.keyword_tags}
              filterAction={SET_INSIGHTS_FILTERS}
              listAction={SET_KEYWORDS_FILTER}
            />
            <ChecklistFilter
              type="categories"
              filters={categoriesList.filters}
              items={categoriesList}
              fetch={(clear) => getCategories(clear)}
              selectedItems={filters.categories}
              filterAction={SET_INSIGHTS_FILTERS}
              listAction={SET_CATEGORIES_FILTER}
            />
            <EntityFilter
              title="brands"
              type="brand_ids"
              filters={brandsList.filters}
              items={brandsList}
              fetch={(clear) => getBrands(clear)}
              selectedItems={filters.brand_ids}
              filterAction={SET_INSIGHTS_FILTERS}
              listAction={SET_BRANDS_FILTER}
            />
          </FilterSideMenu>
        </LeftSideBarWrapper>
        <PageContent>
          <SelectedFiltersBar
            filters={filters}
            filterAction={SET_INSIGHTS_FILTERS}
            hiddenFilters={['content_type']}
          />
          <ExportPDFButton onClick={() => toggleComingSoonModal()}>EXPORT AS PDF</ExportPDFButton>
          <InsightsTabContainer>
            <ComponentTabContainer>
              <ComponentTab tabName="Content">
                <ContentInsightsTab fetchData={getContentInsights} entityId={entityId} entityType={entityType} />
              </ComponentTab>
              <ComponentTab tabName="Brands">
                <BrandsInsightsTab fetchData={getBrandsInsights} entityId={entityId} entityType={entityType} />
              </ComponentTab>
              <ComponentTab tabName="Keywords">
                <KeywordsInsightsTab fetchData={getKeywordsInsights} entityId={entityId} entityType={entityType} />
              </ComponentTab>
            </ComponentTabContainer>
          </InsightsTabContainer>
        </PageContent>
      </PageBody>
    );
  }
}

const mapStateToProps = ({
  BrandsList: { brandsList },
  KeywordsList: { keywordsList },
  CategoriesList: { categoriesList },
  Insights: { filters },
}) => ({ categoriesList, keywordsList, brandsList, filters });

const mapDispatchToProps = (dispatch, { match: { params: { entityId } }, entityType }) => ({
  updateContentType: (contentType) => dispatch({ type: SET_INSIGHTS_FILTERS, filters: { content_type: contentType } }),
  getKeywords: (clear) => dispatch(fetchPublisherKeywords(clear, entityId)),
  getCategories: clear => dispatch(fetchPublisherCategories(clear, entityId)),
  getBrands: (clear) => dispatch(fetchPublisherBrands(clear, entityId)),
  getBrandsInsights: (clear, id) => dispatch(fetchPublishersBrandsInsights(clear, id)),
  getContentInsights: (id) => dispatch(fetchEntityContentInsights(id, entityType)),
  getKeywordsInsights: (clear, id) => dispatch(fetchPublishersKeywordsInsights(clear, id)),
  toggleComingSoonModal: () => dispatch({ type: TOGGLE_COMING_SOON_MODAL, modal: 'comingSoonInsightsExport' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublisherInsightsView);
